import React, { useEffect, useState } from "react";
import { api, BRL } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Plus, Trash2, Save, MapPin } from "lucide-react";
import { toast } from "sonner";

export default function NeighborhoodManager() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [fee, setFee] = useState("");

  const load = () => api.get("/admin/neighborhoods").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name || fee === "") {
      toast.error("Informe o bairro e a taxa.");
      return;
    }
    try {
      await api.post("/admin/neighborhoods", {
        name,
        fee: parseFloat(String(fee).replace(",", ".")) || 0,
        active: true,
      });
      setName(""); setFee("");
      toast.success("Bairro adicionado!");
      load();
    } catch { toast.error("Erro ao adicionar."); }
  };

  const save = async (nb) => {
    try {
      await api.put(`/admin/neighborhoods/${nb.id}`, {
        name: nb.name,
        fee: parseFloat(String(nb.fee).replace(",", ".")) || 0,
        active: nb.active,
      });
      toast.success("Salvo!");
      load();
    } catch { toast.error("Erro ao salvar."); }
  };

  const del = async (nb) => {
    if (!window.confirm(`Remover o bairro "${nb.name}"?`)) return;
    try {
      await api.delete(`/admin/neighborhoods/${nb.id}`);
      toast("Bairro removido");
      load();
    } catch { toast.error("Erro ao remover."); }
  };

  const upd = (id, key, val) =>
    setItems((prev) => prev.map((n) => (n.id === id ? { ...n, [key]: val } : n)));

  return (
    <div className="max-w-2xl">
      <div className="mb-4">
        <h2 className="font-display font-black text-2xl tracking-tight">Taxas de entrega</h2>
        <p className="text-sm text-stone-400">Cadastre os bairros e o valor da entrega. O cliente escolhe o bairro no pedido.</p>
      </div>

      <div className="bg-[#1C1917] border border-[#292524] rounded-xl p-4 mb-5">
        <p className="text-sm font-semibold mb-3 flex items-center gap-2"><Plus className="w-4 h-4" /> Novo bairro</p>
        <div className="flex flex-col sm:flex-row gap-3 sm:items-end">
          <div className="flex-1">
            <Label className="text-stone-300">Bairro</Label>
            <Input data-testid="nb-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Ex.: Centro" className="bg-[#0C0A09] border-[#292524] text-stone-100" />
          </div>
          <div className="w-full sm:w-32">
            <Label className="text-stone-300">Taxa (R$)</Label>
            <Input data-testid="nb-fee" value={fee} onChange={(e) => setFee(e.target.value)} placeholder="0,00" className="bg-[#0C0A09] border-[#292524] text-stone-100" />
          </div>
          <button onClick={add} data-testid="add-neighborhood-btn" className="rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm font-semibold hover:bg-primary/90 transition-colors whitespace-nowrap">
            Adicionar
          </button>
        </div>
      </div>

      <div className="space-y-2">
        {items.length === 0 && (
          <p className="text-sm text-stone-500 text-center py-8">Nenhum bairro cadastrado ainda.</p>
        )}
        {items.map((nb) => (
          <div key={nb.id} data-testid={`neighborhood-${nb.id}`} className="bg-[#1C1917] border border-[#292524] rounded-xl p-3 flex flex-col sm:flex-row sm:items-center gap-3">
            <MapPin className="w-4 h-4 text-stone-500 hidden sm:block" />
            <Input value={nb.name} onChange={(e) => upd(nb.id, "name", e.target.value)} className="flex-1 bg-[#0C0A09] border-[#292524] text-stone-100" />
            <div className="flex items-center gap-1 w-full sm:w-32">
              <span className="text-stone-400 text-sm">R$</span>
              <Input value={nb.fee} onChange={(e) => upd(nb.id, "fee", e.target.value)} className="bg-[#0C0A09] border-[#292524] text-stone-100" />
            </div>
            <div className="flex items-center gap-2">
              <span className="text-xs text-stone-400">Ativo</span>
              <Switch checked={nb.active !== false} onCheckedChange={(v) => upd(nb.id, "active", v)} data-testid={`nb-active-${nb.id}`} />
            </div>
            <div className="flex gap-2">
              <button onClick={() => save(nb)} data-testid={`save-nb-${nb.id}`} className="inline-flex items-center gap-1 text-xs rounded-full border border-[#292524] px-3 py-2 hover:bg-[#292524] transition-colors">
                <Save className="w-3.5 h-3.5" /> Salvar
              </button>
              <button onClick={() => del(nb)} data-testid={`del-nb-${nb.id}`} className="inline-flex items-center justify-center rounded-full border border-[#292524] w-9 py-2 text-destructive hover:bg-destructive/10 transition-colors">
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
